import * as t from 'io-ts'
import {
  AndroidPlatformProperties,
  APINode,
  PlatformAttributes,
  PlatformPayloadCodec,
  SnsPlatform
} from '../../../common/types'

export type PlatformAuthenticationType = 'certificate' | 'token'

// NOTE: trying to not go too crazy here, doing the best I can do. THe setup was attempting to reuse
//       the request and reply structures, but there is too much of a difference. An attempt, please forgive me :)

export const BaseNotificationPlatformCodec = t.intersection([
  t.type({appId: t.string}),
  t.partial({
    enabled: t.boolean,
    created: t.string,
    arn: t.union([t.string, t.undefined])
  }),
  PlatformPayloadCodec
])

export type BaseNotificationPlatform = t.TypeOf<
  typeof BaseNotificationPlatformCodec
>

export const NotificationPlatformCodec = t.intersection([
  t.type({id: t.string}),
  BaseNotificationPlatformCodec
])

export type NotificationPlatform = t.TypeOf<typeof NotificationPlatformCodec>

export interface PlatformResponse extends APINode {
  attributes: BaseNotificationPlatform & {platform: SnsPlatform} & Partial<{
      properties: AndroidPlatformProperties
      attributes: {
        AuthenticationMethod: 'Token' | 'Key'
        Enabled: 'true' | 'false'
      }
    }>
}

export type PlatformAttributesSetter = (
  setter:
    | Partial<PlatformAttributes>
    | ((previous: Partial<PlatformAttributes>) => PlatformAttributes)
) => void
